import clsx from "clsx";
import { useEffect, useRef, useState } from "react";
import * as styles from "./styles.module.scss";

// Utility function to replace semicolons with semicolons followed by HTML line breaks
const processCellContent = (content: string) => {
  // Replace semicolons with semicolon + HTML line break
  return content.replace(/;/g, ";<br/>");
};

export function RichTextTable({ table }: Partial<TableComponent>) {
  const tableContainerRef = useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    if (!tableContainerRef?.current) return;
    if (
      tableContainerRef.current &&
      tableContainerRef.current.scrollWidth >
        tableContainerRef.current.clientWidth
    ) {
      setIsOverflowing(true);
    } else {
      setIsOverflowing(false);
    }
  }, [table]);

  if (!table) return null;
  const isLargeTable = table?.thead?.length >= 4;
  return (
    <div
      ref={tableContainerRef}
      className={clsx(
        styles.customTableContainer,
        isLargeTable ? styles.largeTable : "",
        isOverflowing ? styles.hasOverflow : ""
      )}
    >
      <table className={styles.customTable}>
        <thead>
          <tr>
            {table &&
              table.thead.map((item) => <th key={item._uid}>{item.value}</th>)}
          </tr>
        </thead>
        <tbody>
          {table &&
            table.tbody.map((item) => (
              <tr key={item._uid}>
                {item.body.map((cell) => (
                  <td
                    key={cell._uid}
                    dangerouslySetInnerHTML={{
                      __html: processCellContent(cell.value),
                    }}
                  ></td>
                ))}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}
